<template>
  <section>
    <div class="dashboard-container flex flex-wrap flex-col">
      <SmartRow>
        <SmartTitle
          class="form-list__title mb-2 mt-2 ml-1"
          weight="medium"
          heading="1"
        >
          Controles GU
        </SmartTitle>
      </SmartRow>
      <SmartRow class="mx-auto">
        <SmartButtonDash
          v-for="service in items"
          :key="service.title"
          v-bind="service"
          @click.native="changeRoute(service.name)"
          :action="service.action"
          class="lg:col-4 md:col-12 sm:col-12 flex flex-wrap"
        />
        <SmartCard />
      </SmartRow>
    </div>
  </section>
</template>

<script>
import { mapGetters } from "vuex";
import gridItems from "constants/gridItemRoles";

export default {
  computed: {
    ...mapGetters({
      webPermission: "auth/webPermission",
    }),
    items() {
      return gridItems.filter((item) =>
        this.webPermission.find((p) => p.name === item.permission)
      );
    },
  },
  methods: {
    changeRoute(routerName) {
      this.$router.push({ name: routerName });
    },
  },
};
</script>
